// @ts-strict-ignore
// todo - bring in all other ui selectors

import { workflowNodeType } from 'flow/service/graph';
import type { PublicId } from 'flow/store/engine/types';
import type { State } from '~/store';

export function selectIsSearchBoxVisible(state: State) {
  return state.workflowEditor.ui?.search.isSearchBoxVisible;
}

export function selectSearchQuery(state: State) {
  return state.workflowEditor.ui?.search.query;
}

export function selectSearchMatchIndex(state: State) {
  return state.workflowEditor.ui?.search.matchIndex;
}

export function selectNodeContainerState(state: State) {
  return state.workflowEditor.ui.nodeContainers;
}

export function selectSnippetCollapsedStates(state: State) {
  return state.workflowEditor.ui.nodeContainers.snippets;
}

export function selectNodeFolderState(state: State) {
  // only supports input attributes for now
  return state.workflowEditor.ui.nodeContainers[workflowNodeType.inputAttribute];
}

export function selectSnippetCollapsedState(snippetId: PublicId) {
  return function selector(state: State) {
    return state.workflowEditor.ui.nodeContainers.snippets[snippetId];
  };
}

export function selectHoveredNodeId(state: State) {
  return state.workflowEditor.ui.hoveredNodeId;
}

export function selectShouldRenderCriticalNodePath(state: State) {
  return state.workflowEditor.ui.shouldRenderCriticalNodePath;
}

export function selectEditorContainerType(state: State) {
  return state.workflowEditor.ui.editorContainerType;
}

export function selectRuleBuilderIsDragging(state: State) {
  return state.workflowEditor.ui.ruleBuilder.isDragging;
}

export function selectRuleBuilderHighlightedRuleId(state: State) {
  return state.workflowEditor.ui.ruleBuilder.highlightedRuleId;
}

export function selectRuleBuilderHoveredRuleIndex(state: State) {
  return state.workflowEditor.ui.ruleBuilder.hoveredRuleIndex;
}

export function selectRuleBuilderActiveRuleNumberDropdown(state: State) {
  return state.workflowEditor.ui.ruleBuilder.activeRuleNumberDropdown;
}

export function selectRuleBuilderPendingGroupInfo(state: State) {
  return state.workflowEditor.ui.ruleBuilder.pendingGroup;
}

export function selectRuleBuilderHasPendingGroup(state: State) {
  return state.workflowEditor.ui.ruleBuilder.pendingGroup.startIndex !== null;
}

export function selectRuleBuilderPanelBoxContainerWidth(state: State) {
  return state.workflowEditor.ui.ruleBuilder.panelBoxContainerWidth;
}

export function selectRuleBuilderActiveSubEditor(state: State) {
  return state.workflowEditor.ui.ruleBuilder.activeSubEditor;
}

export function selectPendingGroup(state: State) {
  return state.workflowEditor.ui.expressionBuilder.pendingGroup;
}
